import { LayoutGrid, Table2 } from "lucide-react"

type TourListView = "table" | "cards"

type TourViewSwitchType = {
    view: TourListView
    onChange: (view: TourListView) => void
}

export default function TourViewSwitch(props: TourViewSwitchType) {
    const iconButton = (active: boolean) =>
        `btn btn-ghost btn-sm px-2 min-h-0 h-9 ${active ? "text-primary" : "text-gray-300 hover:text-gray-400"}`

    return (
        <div className="flex items-center bg-white shadow-lg rounded-default px-1 shrink-0" role="group" aria-label="Ansicht">
            <button
                type="button"
                className={iconButton(props.view === "table")}
                aria-pressed={props.view === "table"}
                title="Tabellenansicht"
                onClick={() => props.onChange("table")}>
                <Table2 className="w-5 h-5" />
            </button>
            <button
                type="button"
                className={iconButton(props.view === "cards")}
                aria-pressed={props.view === "cards"}
                title="Kartenansicht"
                onClick={() => props.onChange("cards")}>
                <LayoutGrid className="w-5 h-5" />
            </button>
        </div>
    )
}
